import { hasFeatureCanary, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { clientType } from 'Environment/getClientType';
import { getCurrentPlatform } from 'Environment/launchResource/device/currentPlatform';
import { platform } from '../constants';

const mobileSpecificFeatureFlagForProtocolHandler: Partial<Record<platform, string>> = {
	[platform.android]: FeatureFlag.SupportClientDetectionAndroid,
	[platform.androidTablet]: FeatureFlag.SupportClientDetectionAndroid,
	[platform.chromeOS]: FeatureFlag.SupportClientDetectionChromeOS,
	[platform.ios]: FeatureFlag.SupportClientDetectionIOS,
	[platform.ipadOS]: FeatureFlag.SupportClientDetectionIOS,
	[platform.linux]: FeatureFlag.UseServerConfigForProtocolHandler,
};

const featureFlagForHybridAADSSO: Partial<Record<platform, string>> = {
	[platform.windows]: FeatureFlag.EnableHybridAADSSO,
	[platform.mac]: FeatureFlag.EnableHybridAADSSOMac,
	[platform.linux]: FeatureFlag.EnableHybridAADSSOLinux,
};

const clientSpecificFeatureFlagForGacsToken: Partial<Record<clientType, string>> = {
	[clientType.native]: FeatureFlag.EnableGlobalAppConfigForProtocolHandler,
	[clientType.browserextension]: FeatureFlag.WSUIGACSHybridViaBXTN,
	[clientType.html5]: FeatureFlag.WSUIGACSHybridForHtml5,
	[clientType.chromeapp]: FeatureFlag.WSUIGACSHybridForChromeApp,
};

export const shouldUseServerConfigForProtocolHandler = (
	config: WorkspaceConfiguration
) => {
	const featureFlagName =
		mobileSpecificFeatureFlagForProtocolHandler[getCurrentPlatform()];
	if (featureFlagName === undefined) {
		return true;
	}
	return hasFeatureCanary(config, featureFlagName);
};

export const isHybridAADSSOFeatureEnabled = (config: WorkspaceConfiguration) => {
	const featureFlagName = featureFlagForHybridAADSSO[getCurrentPlatform()];
	if (featureFlagName === undefined) {
		return false;
	}
	return hasFeatureCanary(config, featureFlagName);
};

export const isHybridGacsFeatureEnabled = (
	config: WorkspaceConfiguration,
	currentClientType: clientType
) => {
	const featureFlagName = clientSpecificFeatureFlagForGacsToken[currentClientType];
	if (!featureFlagName) {
		return false;
	}
	return hasFeatureCanary(config, featureFlagName);
};
